module.exports = __webpack_public_path__ + "media/flags/018-south-korea-50ffa57e.svg";